import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { sha256 } from 'js-sha256';
import { FnI18nService, FnLocalStorageService, FnMenuDataService, FnToasterService } from 'foundation';
import { PosLoginResponseService } from './pos.login.response.service';
import { PosHttpService } from './pos.http.service';
import { Observable } from 'rxjs';
import { PosAppEnum } from '../constants/pos.enum';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosAppService extends FnLocalStorageService{
  constructor(
    
    private http: HttpClient,
    private router:Router,
    private loginResponse:PosLoginResponseService,
    private fn18nService:FnI18nService,
    private menuDataSvcs:FnMenuDataService,
    private posHttpSvcs:PosHttpService,
    private toastr:FnToasterService
  ) {
    super();
  }
  
  public url(): string {
    return `${environment.API_BASE_URL}`;
  }

  calDefaultRedirection = () => {
		if (this.loginResponse.isEnableOnUI) {
		this.loginResponse.menuDataHash
			this.menuDataSvcs.setActiveMenuId(this.loginResponse.menuDataHash.menuItemIDArray[0]);
			this.menuDataSvcs.getActiveMenuItem().subscribe((menue: any) => {
			this.redirectToUrl(menue.url, false)
			});
		} 
    else {
			this.redirectToUrl('app/main/home', false);
		}
	};

  redirectToUrl = (redirectUrl: string, isRenamed?: boolean) => {
		this.router.navigate([redirectUrl]);
	};

  setAppSession(){
    this.setItem(PosAppEnum.APP_SESSION,this.loginResponse.authToken)
  }

  getAppSession() :{}{
    return this.getItem(PosAppEnum.APP_SESSION);
  }

  deleteAppSession(){
    this.removeItem(PosAppEnum.APP_SESSION);
  }

  setAuthToken(token:any){
    this.loginResponse.authToken= token;
  }
  setLoginResponse(data:any){
    this.loginResponse.setLoginResponse(data);
    this.setAppSession();
    this.fn18nService.loadTranslateMessage('en', this.loginResponse.labelHash);
		this.menuDataSvcs
			.loadMenuData(this.loginResponse.menuDataHash);
		this.calDefaultRedirection();
  }
  
  recallLoginResponse(data:any){
    this.loginResponse.setLoginResponse(data);
    this.fn18nService.loadTranslateMessage('en', this.loginResponse.labelHash);
		this.menuDataSvcs
			.loadMenuData(this.loginResponse.menuDataHash);
  }
}
